/*
* String機能拡張
*/
import jpCalendar from '@/js/japaneseCalendar.js';

Object.assign(String.prototype, {
	// 文字列から日付オブジェクトへ (不正時はundefined、null時は現在日時)
	toDate(value, timeonly) {
		if (arguments) {
			for (let i in arguments) {
				let arg = arguments[i];
				if (typeof(arg) == 'boolean') {
					timeonly = arg;
					if (arguments.length == 1) {
						value = undefined;
					}
				}
				if (typeof(arg) == 'string') {
					value = arg;
					if (arguments.length == 1) {
						timeonly = undefined;
					}
				}
			}
		}
		
		if (value == undefined) {
			value = this;
		}
		if ((timeonly != undefined) && (timeonly != "") && (timeonly === true)) {
			timeonly = true;
		} else {
			timeonly = false;
		}
		if (value == "") {
			let now = new Date();
			if (!timeonly) {
				return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
			}
			return now;
		}
		
		let now = new Date();
		let year = now.getFullYear();
		let month = now.getMonth();
		let day = now.getDate();
		let hour = now.getHours();
		let minute = now.getMinutes();
		let second = now.getSeconds();
		let millisecond = 0;
		let mm = 0;
		
		if (!timeonly) {
			hour = 0;
			minute = 0;
			second = 0;
			mm = 1;
		}
		
		if (value.match(/^\d{1,2}$/)) {
			if (!timeonly) {
				day = value;
			} else {
				second = value;
			}
		} else if (value.match(/^\d{3,4}$/)) {
			let v1 = "";
			let v2 = "";
			
			if (value.length == 3) {
				v1 = (value + "").substr(0, 1) - mm;
				v2 = (value + "").substr(1, 2) - 0;
			} else {
				v1 = (value + "").substr(0, 2) - mm;
				v2 = (value + "").substr(3, 2) - 0;
			}
			if (!timeonly) {
				month = v1;
				day = v2;
			} else {
				minute = v1;
				second = v2;
			}
		} else if (value.match(/^\d{5,6}$/)) {
			let v1 = "";
			let v2 = "";
			let v3 = "";
			
			if (value.length == 5) {
				v1 = (value + "").substr(0, 1) - 0;
				v2 = (value + "").substr(1, 2) - mm;
				v3 = (value + "").substr(3, 2) - 0;
			} else {
				v1 = (value + "").substr(0, 2) - 0;
				v2 = (value + "").substr(2, 2) - mm;
				v3 = (value + "").substr(4, 2) - 0;
			}
			if (!timeonly) {
				if ((v1 + "").length < 3) {
					v1 = "20" + ("0" + v1).slice(-2);
				}
				year = v1;
				month = v2;
				day = v3;
			} else {
				hour = v1;
				minute = v2;
				second = v3;
			}
		} else if (value.match(/^\d{7,8}$/)) {
			let v1 = "";
			let v2 = "";
			let v3 = "";
			
			if (value.length == 7) {
				v1 = (value + "").substr(0, 3) - 0;
				v2 = (value + "").substr(3, 2) - mm;
				v3 = (value + "").substr(5, 2) - 0;
			} else {
				v1 = (value + "").substr(0, 4) - 0;
				v2 = (value + "").substr(4, 2) - mm;
				v3 = (value + "").substr(6, 2) - 0;
			}
			if (!timeonly) {
				if ((v1 + "").length < 4) {
					v1 = "2" + v1;
				}
				year = v1;
				month = v2;
				day = v3;
			} else {
				return undefined;
			}
		} else if (value.match(/^(\d{1,2})(\D+)(\d{1,2})(\D*)$/)) {
			let v1 = RegExp.$1 - mm;
			let v2 = RegExp.$3 - 0;
			let dl = RegExp.$2;
			
			if (!timeonly) {
				month = v1;
				day = v2;
			} else {
				minute = v1;
				second = v2;
			}
		} else if (value.match(/^(\D*)(\d{1,4})(\D+)(\d{1,2})(\D+)(\d{1,2})(\D*)$/)) {
			let gg = RegExp.$1;
			let v1 = RegExp.$2 - 0;
			let v2 = RegExp.$4 - mm;
			let v3 = RegExp.$6 - 0;
			let dl1 = RegExp.$3;
			let dl2 = RegExp.$5;
			
			if (!timeonly) {
				if ((v1 + "").length < 3) {
					if (gg != "") {
						//-- 和暦
						v1 = jpCalendar.warekiToSeireki(gg, v1);
						if (v1 == "") {
							return undefined;
						}
					} else {
						v1 = "20" + ("0" + v1).slice(-2);
					}
				} else if ((v1 + "").length < 4) {
					v1 = "2" + v1;
				}
				year = v1;
				month = v2;
				day = v3;
			} else {
				hour = v1;
				minute = v2;
				second = v3;
			}
		} else if (value.match(/^(\D*)(\d{1,4})(\D+)(\d{1,2})(\D+)(\d{1,2})(\D+)(\d{1,2})/)) {
			let gg = RegExp.$1;
			let wv = RegExp.$2;
			let v1 = wv;
			let dl1 = RegExp.$3;
			let v2 = RegExp.$4;
			let dl2 = RegExp.$5;
			let v3 = RegExp.$6;
			let dl3 = RegExp.$7;
			
			if ((v1 + "").length < 3) {
				if (gg != "") {
					//-- 和暦
					v1 = jpCalendar.warekiToSeireki(gg, v1);
					if (v1 == "") {
						return undefined;
					}
				} else {
					v1 = "20" + ("0" + v1).slice(-2);
				}
			} else if ((v1 + "").length < 4) {
				v1 = "2" + v1;
			}
			let wdate = v1 + "/" + v2 + "/" + v3 + " ";
			let wstr = gg + wv + dl1 + v2 + dl2 + v3 + dl3;
			let tstr = value.substr(wstr.length);
			tstr = tstr.replace(/\D+/g, ":");
			value = wdate + tstr;
			
			let data = new Date(value);
			if ((typeof(data) == 'object') && (data != "Invalid Date")) {
				if ((data.getMonth() != (v2 - 1)) || (data.getDate() != v3)) {
					return undefined;
				} 
				return data;
			} else {
				return undefined;
			}
		} else {
			let data = new Date(value);
			if ((typeof(data) == 'object') && (data != "Invalid Date")) {
				return data;
			} else {
				return undefined;
			}
		}
		
		
		let result = new Date(year, month, day, hour, minute, second, millisecond);
		if ((typeof(result) != 'object') || (result == "Invalid Date")) {
			return undefined;
		}
		if ((result.getFullYear() != year) || (result.getMonth() != month) || (result.getDate() != day) || (result.getHours() != hour) || (result.getMinutes() != minute) || (result.getSeconds() != second)) {
			return undefined;
		}
		
		return result;
	}
});



// WEBPACK FOOTER //
// ./src/js/string.js